<template>
  <div></div>
</template>

<script>
export default {
  name: 'edit',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
